module.exports = __webpack_public_path__ + "media/images/bg/separator-1cd954538b41780016c5c711483d7db7.svg";